export enum BookingErrorType {
  // booked
  WORKPLACE_BOOKED_IN_THE_MEANTIME = "workplace_booked_in_the_meantime",
  CONFERENCEZONE_BOOKED_IN_THE_MEANTIME = "conferencezone_booked_in_the_meantime",
  PARKINGPLACE_BOOKED_IN_THE_MEANTIME = "parkingplace_booked_in_the_meantime",
  ELECTRICCHARGINGPLACE_BOOKED_IN_THE_MEANTIME = "electricchargingplace_booked_in_the_meantime",
  NO_WORKPLACE_BOOKING_SCHEDULE_AT_LOCATION = "no_workplace_booking_schedule_at_location",
  NO_WORKPLACE_INVENTORY_AT_LOCATION = "no_workplace_inventory_at_location",
  // disabled
  LOCATION_BOOKING_DISABLED_BY_ADMIN_IN_THE_MEANTIME = "location_booking_disabled_by_admin_in_the_meantime",
  FLOOR_BOOKING_DISABLED_BY_ADMIN_IN_THE_MEANTIME = "floor_booking_disabled_by_admin_in_the_meantime",
  WORKPLACE_BOOKING_DISABLED_BY_ADMIN_IN_THE_MEANTIME = "workplace_booking_disabled_by_admin_in_the_meantime",
  CONFERENCEZONE_BOOKING_DISABLED_BY_ADMIN_IN_THE_MEANTIME = "conferencezone_booking_disabled_by_admin_in_the_meantime",
  PARKINGPLACE_BOOKING_DISABLED_BY_ADMIN_IN_THE_MEANTIME = "parkingplace_booking_disabled_by_admin_in_the_meantime",
  ELECTRICCHARGINGPLACE_BOOKING_DISABLED_BY_ADMIN_IN_THE_MEANTIME = "electricchargingplace_booking_disabled_by_admin_in_the_meantime",
  VISITOR_EMAIL_DUPLICATED = "visitor_email_duplicated",
  // blocked
  WORKPLACE_BLOCKED_BY_ADMIN_IN_THE_MEANTIME = "workplace_blocked_by_admin_in_the_meantime",
  CONFERENCEZONE_BLOCKED_BY_ADMIN_IN_THE_MEANTIME = "conferencezone_blocked_by_admin_in_the_meantime",
  PARKINGPLACE_BLOCKED_BY_ADMIN_IN_THE_MEANTIME = "parkingplace_blocked_by_admin_in_the_meantime",
  ELECTRICCHARGINGPLACE_BLOCKED_BY_ADMIN_IN_THE_MEANTIME = "electricchargingplace_blocked_by_admin_in_the_meantime"
}
